var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 88,
  height: 88,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M44.5 5C22.706 5 5 22.706 5 44.5S22.706 84 44.5 84 84 66.294 84 44.5 66.294 5 44.5 5Zm0 3.435c19.938 0 36.065 16.127 36.065 36.065S64.438 80.565 44.5 80.565 8.435 64.438 8.435 44.5 24.562 8.435 44.5 8.435Z",
  fill: "#DC632A"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m56.029 31.118-24.392 25.43M31.118 31.638l25.43 24.392",
  stroke: "#DC632A",
  strokeWidth: 3,
  strokeLinecap: "round"
})));
export default SvgError;